import * as zod from 'zod';

export default zod.object({
  currentActivity: zod.enum([
    'none',
    'requestingPlan',
    'planning',
    'receivingPlan',
    'moving',
    'paused',
  ]),
});
